module.exports = __webpack_public_path__ + "static/media/3DPPA1.1454503d.jpg";